<template>
  <el-dialog
    :title="Baslik"
    :visible="ModalOlayi"
    center
    width="50%">
    <a @click="$emit('ModalOlayi', false)" class="ModalKapat"><i class="el-icon-close"></i></a>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-form :model="data" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="Ticari Ünvan" prop="Unvan">
            <el-input v-model="data.Unvan"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="Telefon" prop="Telefon">
            <el-input v-mask="'### ### ## ##'" v-model="data.Telefon"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Mail" prop="Mail">
            <el-input v-model="data.Mail"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Vergi No" prop="vNo">
            <el-input v-mask="'###########'" v-model="data.vNo"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Vergi Dairesi" prop="vDairesi">
            <el-input v-model="data.vDairesi"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="Banka Adı" prop="bBilgi">
            <el-input v-model="data.bBilgi.Adi"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item label="IBAN" prop="bBilgi">
            <el-input v-mask="'TR ## #### #### #### #### #### ####'" v-model="data.bBilgi.Iban"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">

        <el-col :span="24">
          <el-form-item label="Adres" prop="bBiAdreslgi">
            <el-input type="textarea" v-model="data.Adres"></el-input>
          </el-form-item>
        </el-col>
      </el-row>


    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" v-if="!lo" size="medium" @click="Submit()" icon="el-icon-check">
        {{$t('eGenel.0')}}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import Yukleniyor from "../../../Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    props: {
      ModalOlayi: Boolean,
      Baslik: String,
      data: {
        type: Object,
        require: true,
      },
    },
    data() {
      return {
        lo: false,
        FormHata: {
          Unvan: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          vNo: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },

      }
    },
    methods: {
      Submit() {
        this.$refs['Form'].validate((valid) => {
          if (valid) {
            this.lo = true;
            if (this.data.id) {
              // DÜZENLE
              this.$store.dispatch("Put", {
                ...this.data,
                path: 'muhasebe/cari/' + this.data.id
              })
                .then(response => {
                  this.lo = false;
                  if (response.Durum == "OK") {
                    this.$emit("ModalOlayi", false);
                    this.$message.success(response.Mesaj);
                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })

            } else {
              // EKLE
              this.$store.dispatch("Post", {...this.data, path: 'muhasebe/cari'})
                .then(response => {
                  this.lo = false;
                  if (response.Durum == "OK") {
                    this.$emit("ModalOlayi", false);
                    this.$message.success(response.Mesaj);
                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })
            }
          }
        });

      }
    },
    created() {
      if (!this.data.bBilgi) {
        this.data.bBilgi = {
          Adi: null,
          Iban: null
        }

      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/Pack/Muhasebe/cari/FormModal.vue